import Cookies from 'js-cookie'
import axios from 'axios'
import {
	Message
} from 'element-ui'
// import Auth from '@/util/auth'

const state = {
	token: '',
	appName: '',
	HOST: '',
	pageRefresh: false ,//是否需要刷新页面
	defaultOpenedsArray: []
}

const mutations = {
	setAppName: (state, data) => {
		console.log('设置应用名为：', data);
		state.appName = data;
	},
	setHost: (state, data) => {
		console.log('设置请求地址', data);
		state.HOST = data;
	},
	setPageRefresh: (state, data) => {
		state.pageRefresh = data;
	},
	setDefaultOpenedsArray: (state, data) => {
		state.defaultOpenedsArray = data;
	}
}

const actions = {
	// 用户登录
	login({
		commit
	}, data) {
		return new Promise((resolve) => {
			axios({
				url: data.url,
				method: 'post',
				data: {
					...data.userInfo
				}
			}).then(res => {
				if (res.data.status == 1) {
					commit('user/setUserInfo', res.data.info, {
						root: true
					});
					commit('user/setLoginState', 1, {
						root: true
					})
				}
				resolve(res)
			})
		});
	},

	// 登出
	logout({
		commit
	}) {
		return new Promise((resolve) => {
			commit('user/setUserInfo', '', {
				root: true
			})
			commit('user/setLoginState', false, {
				root: true
			})
			resolve({
				'actionStatus': 1
			})
		})
	},
	// 修改密码/
	changePassword({
		commit
	}, data) {
		console.log(data);
		return new Promise((resolve) => {
			axios({
				url: data.url,
				method: 'post',
				data: data.data
			}).then(res => {
				console.log(res);
				if (res.data.status == 1) {
					Message('密码已修改,请重新登录')
					commit('user/setLoginState', false, {
						root: true
					})
					resolve({
						'status': 1
					})
				}else{
					Message(res.data.msg)
				}
				resolve(res)
			})
		})
	},

	// 重新获取用户信息及Token
	// TODO: 这里不需要提供用户名和密码，实际中请根据接口自行修改
	relogin({
		dispatch,
		commit,
		state
	}) {
		return new Promise((resolve) => {
			// 根据Token进行重新登录
			let token = Cookies.get('token'),
				userName = Cookies.get('userName')

			// 重新登录时校验Token是否存在，若不存在则获取
			if (!token) {
				dispatch("getNewToken").then(() => {
					commit('setToken', state.token)
				})
			} else {
				commit('setToken', token)
			}
			// 刷新/关闭浏览器再进入时获取用户名
			commit('user/setName', decodeURIComponent(userName), {
				root: true
			})
			resolve()
		})
	},

	// 获取新Token
	getNewToken({
		commit,
		state
	}) {
		return new Promise((resolve) => {
			axios({
				url: '/getToken',
				method: 'get',
				param: {
					token: state.token
				}
			}).then((res) => {
				commit("setToken", res.token)
				resolve()
			})
		})
	},

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
